/**
 * Order custom attribute key used to tie customization data to a specific order (cycle).
 * Prevents carried-over attributes from a previous Recharge charge from being used.
 */
export const CUSTOMIZATION_CYCLE_KEY = 'customization_cycle'

/** Keys that store customization selections; used when clearing stale attributes. */
export const CUSTOMIZATION_ATTR_KEYS = {
	cycle: CUSTOMIZATION_CYCLE_KEY,
	cGroupPrefix: 'c_group_',
	bonusItemIds: 'bonus_item_ids'
} as const

export function isCustomizationAttributeKey(key: string): boolean {
	return (
		key === CUSTOMIZATION_ATTR_KEYS.cycle ||
		key === CUSTOMIZATION_ATTR_KEYS.bonusItemIds ||
		key.startsWith(CUSTOMIZATION_ATTR_KEYS.cGroupPrefix)
	)
}
